//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import common, { specState } from "@/assets/js/Common.js";
    import api from "@/assets/js/Api.js";

	import shopCart from '@/components/cusShopCart'


	export default {
		components: {
			shopCart,
		},
		data(){
			return {
                storeId: this.$route.query.storeId,
                storeInfo: {},
                categoryList:[],
                goodsList:[],

                activeCate: {}, // 被选中的分类

				searchContent: '', // 搜索框内容

				argeeDialog:{
                	show: false
				},

                goodsData: {
                    goods_id: '',
                },
                cartQuantity: 0,
			}
        },
		methods:{

            // 开启购物车窗口
			openCart(item){

                let opts = {
                    url: api.goodsDetailInfo,
                    data: {
                        id: item.goods_id,
                    },
                    type:'get'
                };
                common.query(opts).then(res => {
                    const handleSpec = new specState(res.data);
                    this.goodsData = handleSpec.resolve();
                    this.argeeDialog.show=true
                },res => {
                    this.$vux.toast.text(res.message);
                });
            },

            // 查询商品列表，
			queryGoodsList(cate){

                if(typeof cate === 'object'){
                    this.activeCate = cate;
                }

				const opts = {
                    url: api.twoCategoryGoods,
                    data: {
                        id: this.activeCate.cate_id,
                        page: 1,
                        size: 100, // 默认查出全部
                    },
					type:'get'
				};
				common.query(opts).then(res => {
                    const handleSpec = new specState(res.data);
                    this.goodsList = handleSpec.resolve();
                },res => {
                    this.$vux.toast.text(res.message);
                });
            },

            // 查询分类列表,
			queryCategoryList(){

				const opts = {
                    url: api.storeCate,
                    data: {
                        id: this.storeId,
                    },
					type:'get'
				};
				common.query(opts).then(res => {

                    this.categoryList = res.data;
                    this.activeCate  = res.data[0];
                    res.data.length && this.queryGoodsList()

                },res => {
                    this.$vux.toast.text(res.message);
                });
            },

            // 查询商户信息
			queryStoreInfo(){

				const opts = {
                    url: api.partnerInfo,
                    data: {
                        id: this.storeId,
                    },
					type:'get'
				};
				common.query(opts).then(res => {
                    this.storeInfo = res.data
                },res => {
                    this.$vux.toast.text(res.message);
                });
            },

            // 获取搜索内容并跳转到搜索页
			CheckInfo(){

				if(event.keyCode == 13) {
					this.$router.push({name: "search",query: {sContent: this.searchContent}});
				}

            },

            // 购物车数量发生变化
            changeCartQuantity(num){
                this.cartQuantity = num;
            },

            // 查询购物车数据
            queryCartCount(){

                const opts = {
                    url: api.cartCount,
                    data: {},
                    type: 'get'
                }
                common.query(opts).then(res=>{
                    const count = Number(res.data)
                    this.cartQuantity =  count > 0 ? count : 0;
                },res=>{})
            }

		},
		mounted(){

            // this.$router.go(-1);
            this.queryCartCount();
			this.queryStoreInfo()
			this.queryCategoryList()
    	},
	}



// WEBPACK FOOTER //
// ./src/views/pages/store.vue